"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var file_1 = require("./file");
var CodeFile = /** @class */ (function (_super) {
    __extends(CodeFile, _super);
    function CodeFile(id, name, data, type, mime) {
        if (mime === void 0) { mime = "text/plain"; }
        var _this = _super.call(this, id, name, data, {
            mime: mime,
            highlight: type,
        }) || this;
        _this.id = id;
        _this.name = name;
        _this.data = data;
        _this.type = type;
        _this.mime = mime;
        _this.highlighted = [];
        return _this;
    }
    // Return this paste for BSON encoding
    CodeFile.prototype.rawObject = function () {
        return {
            id: this.id,
            name: this.name,
            data: buffer_1.Buffer.from(this.data, 'utf8'),
            meta: this.meta,
        };
    };
    CodeFile.prototype.getBase64Data = function () {
        return buffer_1.Buffer.from(this.data).toString('base64');
    };
    CodeFile.empty = function (id) {
        if (id === void 0) { id = 0; }
        return new CodeFile(id, "", "", "auto");
    };
    return CodeFile;
}(file_1.default));
exports.default = CodeFile;
